<div id="analysis-header" class="analysis-header-container" #headerContainer>
  <ng-content select="app-analysis-header-top-content"></ng-content>

  <div [class.gpb-8]="!hasTabs()">
    <div
      [class]="isFluidContainer && isXlUp ? 'gpx-0' : 'container'"
      [ngClass]="containerClass"
    >
      <div
        class="title-container gpt-8"
        [ngClass]="{
          'd-flex align-items-center': scrolled,
          'gpb-8 gpb-sm-12': hasTabs()
        }"
      >
        <div
          *ngIf="!hideBack"
          class="back d-flex align-items-center flex-shrink d-print-none"
        >
          <ng-content select="gpt-router-back"></ng-content>
        </div>

        <div class="w-100" #titleContent>
          <div
            class="d-flex justify-content-between align-items-center flex-fill"
            [ngClass]="{ 'gpt-8 gpt-sm-0': !scrolled && !hideBack }"
          >
            <ng-content select="app-analysis-header-title"></ng-content>
            <ng-content select="app-analysis-header-button"></ng-content>
          </div>

          <ng-content
            *ngIf="!scrolled"
            select="app-analysis-header-subtitle"
          ></ng-content>
        </div>
      </div>
    </div>

    <div class="container px-0" [ngClass]="containerClass">
      <div class="hz-scroll-parent" [class.gpb-16]="hasTabs()" #scrollRef>
        <div class="hz-scroll-container gpx-16 gpx-md-0">
          <ng-content select="app-analysis-header-tab"></ng-content>
        </div>
      </div>
    </div>

    <ng-content></ng-content>
  </div>
</div>
